import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectOfflineOrders: "selectOfflineOrders [Action]",
  selectOfflineOrdersLoading: "selectOfflineOrdersLoading [Action]",
  selectOfflineOrdersAsync: "selectOfflineOrdersAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const selectOfflineOrdersReducer = (
  state = inistiaState,
  { type, payload },
) => {
  switch (type) {
    case actionTypes.selectOfflineOrders:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectOfflineOrdersLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectOfflineOrdersLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "offlineorder",
    method_type: "select_offline_orders",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectOfflineOrders,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectOfflineOrdersLoading,
      payload: false,
    });
  }
}

export function* selectOfflineOrders() {
  yield takeLatest(actionTypes.selectOfflineOrdersAsync, handleWorker);
}
